import * as types from './types';

// ── Fetch Policies ──────────────────────────────────────────────

export const fetchPoliciesRequest = (params = {}) => ({
  type: types.FETCH_POLICIES_REQUEST,
  payload: params,
});

export const fetchPoliciesSuccess = (data) => ({
  type: types.FETCH_POLICIES_SUCCESS,
  payload: data,
});

export const fetchPoliciesFailure = (error) => ({
  type: types.FETCH_POLICIES_FAILURE,
  payload: error,
});

// ── Fetch Single Policy ─────────────────────────────────────────

export const fetchPolicyRequest = (id) => ({
  type: types.FETCH_POLICY_REQUEST,
  payload: id,
});

export const fetchPolicySuccess = (data) => ({
  type: types.FETCH_POLICY_SUCCESS,
  payload: data,
});

export const fetchPolicyFailure = (error) => ({
  type: types.FETCH_POLICY_FAILURE,
  payload: error,
});

// ── Create Policy ───────────────────────────────────────────────

export const createPolicyRequest = (data, callback) => ({
  type: types.CREATE_POLICY_REQUEST,
  payload: { data, callback },
});

export const createPolicySuccess = (data) => ({
  type: types.CREATE_POLICY_SUCCESS,
  payload: data,
});

export const createPolicyFailure = (error) => ({
  type: types.CREATE_POLICY_FAILURE,
  payload: error,
});

// ── Update Policy ───────────────────────────────────────────────

export const updatePolicyRequest = (id, data, callback) => ({
  type: types.UPDATE_POLICY_REQUEST,
  payload: { id, data, callback },
});

export const updatePolicySuccess = (data) => ({
  type: types.UPDATE_POLICY_SUCCESS,
  payload: data,
});

export const updatePolicyFailure = (error) => ({
  type: types.UPDATE_POLICY_FAILURE,
  payload: error,
});

// ── Delete Policy ───────────────────────────────────────────────

export const deletePolicyRequest = (id, callback) => ({
  type: types.DELETE_POLICY_REQUEST,
  payload: { id, callback },
});

export const deletePolicySuccess = (id) => ({
  type: types.DELETE_POLICY_SUCCESS,
  payload: id,
});

export const deletePolicyFailure = (error) => ({
  type: types.DELETE_POLICY_FAILURE,
  payload: error,
});

// ── Utilities ───────────────────────────────────────────────────

export const clearPolicyError = () => ({
  type: types.CLEAR_POLICY_ERROR,
});
